import { Component, effect, inject, Input } from '@angular/core';
import { CustomGridStackWidget } from '../../../services/grid-widget-config.service';
import { WidgetStore } from '../../../stores/grid/widget.state';
import { getState } from '@ngrx/signals';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { CheckAllComponent } from '../../atoms/check-all/check-all.component';

@Component({
  selector: 'app-wegweiser-widget-config',
  standalone: true,
  imports: [CheckboxModule, FormsModule, CheckAllComponent],
  templateUrl: './wegweiser-widget-config.component.html',
  styleUrl: './wegweiser-widget-config.component.scss',
})
export class WegweiserWidgetConfigComponent {
  readonly widgetStore = inject(WidgetStore);
  @Input() widget!: CustomGridStackWidget;

  years: number[] = [];

  constructor() {
    effect(() => {
      const widgetState = getState(this.widgetStore);
      this.setup();
    });
  }

  /**
   * Initializes the `years` property by extracting data from `wegweiserData`
   * within the widget structure. If no data is found, it assigns an empty array.
   *
   * @return {void} Does not return any value.
   */
  setup(): void {
    this.years = this.widget.widget.wegweiserData?.years || [];
  }

  /**
   * Updates the current widget by logging its current state and passing it to the widget store for an update.
   * The update is performed with a forced update option.
   *
   * @return {void} Does not return a value.
   */
  updateWidget(): void {
    this.widgetStore.update(this.widget._id, this.widget, true);
  }
}
